module.exports = __webpack_public_path__ + "static/media/ehealth_cbhr_banner_desktop.ba5f0574.jpg";